export default "__VITE_ASSET__1Vs7hdV3__"